import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Radio } from '../../../../../common/html/radio'
import { TYPE_TRANSFER } from '../constants'

export const BankTransfer = ({ currencyType, setCurrencyType }) => {
  return (
    <div className="dFlex" style={{ gap: 26, marginTop: 14 }}>
      <Element className="fw600">
        <Translate value="cartAndOrders.orderConfirmation.currencyOfPayment" />
      </Element>
      <div className="dFlex gap2">
        {Object.values(TYPE_TRANSFER).map((key) => {
          return (
            <Radio
              key={key}
              isI18n={false}
              title={key}
              mlTitle={9}
              inputStyle={{
                width: 17,
                height: 17,
                borderWidth: '2px',
                borderRadius: '50%',
              }}
              value={key}
              activeValue={currencyType}
              onChange={() => setCurrencyType(key)}
            />
          )
        })}
      </div>
    </div>
  )
}
